import borders from "assets/theme-dark/base/borders";
import boxShadows from "assets/theme-dark/base/boxShadows";
import colors from "assets/theme-dark/base/colors";

const { borderRadius } = borders;
const { xxl } = boxShadows;
const { container } = colors.background;

const dialog = {
  styleOverrides: {
    root: {
      backdropFilter: "blur(2px)",
      zIndex: 9600,
    },

    paper: ({ theme }) => ({
      borderRadius: borderRadius.lg,
      boxShadow: xxl,
      background: container,
      [theme.breakpoints.down("sm")]: {
        margin: 8,
        width: "calc(100% - 16px)",
        maxWidth: "calc(100% - 16px)",
      },
    }),

    paperFullScreen: {
      borderRadius: 0,
    },
  },
};

export default dialog;
